export default __webpack_public_path__ + "static/media/pathname_script.1c29bd98.gif";